import { useEffect } from 'react';
import Loader from '../../components/common/Loader';
import { useToastMessage } from '../../../utils/uiUtils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Paths } from '../../../routes/paths';
import { ApiStatus } from '../../../types/enums/ApiStatus';
import ConnectionError from '../../components/common/ConnectionError';
import ServerError from '../../components/common/ServerError';
import { useQuery } from '../../../utils/urlUtils';
import { useAuthStore } from '../../../stores/authStore';
import { AuthStatus } from '../../../types/enums/AuthStatus';
import { useLogoutSuccess } from '../../../utils/authUtils';
import { useSsoLogoutStore } from '../../../stores/ssoLogoutStore';

const SsoLogoutPage: React.FC = () => {
  const { showErrorMessage, showSuccessMessage } = useToastMessage();
  const { t } = useTranslation(['auth', 'common']);
  const navigate = useNavigate();
  const query = useQuery();
  const token = query.get('token') ?? '';
  const { status, data, apiCall } = useSsoLogoutStore();
  const { status: authStatus } = useAuthStore();
  const { logoutSuccess } = useLogoutSuccess();

  useEffect(() => {
    if (!token) {
      navigate(Paths.Root);
    }
    apiCall(token);
  }, [token]);

  useEffect(() => {
    if (status == ApiStatus.ValidationError) {
      showErrorMessage(t('common:ssoLogoutFailed'));
      navigate(Paths.Root);
    } else if (status == ApiStatus.Success) {
      if (authStatus == AuthStatus.Unauthenticated) {
        showErrorMessage(t('common:ssoLogoutAlready'));
        navigate(Paths.Root);
      } else {
        showSuccessMessage(t('common:ssoLogoutSuccess'));
        logoutSuccess(data as Record<string, any>, true);
        navigate(Paths.Root);
      }
    } else if (
      status == ApiStatus.ConnectionError ||
      status == ApiStatus.ServerError
    ) {
      navigate(Paths.Root);
    }
  }, [status]);

  if (status == ApiStatus.Connecting) {
    return <Loader />;
  } else if (status == ApiStatus.ConnectionError) {
    return <ConnectionError onRetry={() => apiCall(token)} />;
  } else if (status == ApiStatus.ServerError) {
    return <ServerError onRetry={() => apiCall(token)} />;
  } else {
    return <Loader />;
  }
};

export default SsoLogoutPage;
